import React from 'react';
import { connect } from 'react-redux';
import { selectQuestionAnswers, updateAnswer } from '../../redux/questionsSlice';

import InputControl from '../inputForm/InputControl';

import { DATA_TYPE_STRING, INPUT_LAYOUT_TYPE_INLINE, INPUT_TYPE_CHECKBOX, INPUT_TYPE_RADIO, INPUT_TYPE_RANGE } from '../componentConstants';

import PropTypes from 'prop-types';
import './QuestionAnswersUI.css';

class QuestionAnswersUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answers: props.answers ?? {}
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.answers && !prevProps.answers) {
      const answersState = {};
      this.props.answers.forEach(answer => {
        answersState[answer.questionId] = {
          questionId: answer.questionId,
          id: answer.id,
          answer: answer.answer || '',
          updatedOn: answer.updatedOn
        };
      });
      this.setState({ answers: answersState });
    }
  }

  handleAnswerChange(answer, value) {
    const { entityName, typeId, recordId, cacheKey, dispatch } = this.props;
    dispatch(updateAnswer({ entityName, typeId: typeId ?? 0, recordId: recordId ?? 0, cacheKey,
      questionId: answer.questionId, answerValue: value, updatedOn: answer.updatedOn
    }));

    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        [answer.questionId]: {
          questionId: answer.questionId,
          id: answer.id,
          answer: value,
          updatedOn: answer.updatedOn
        }
      }
    }), () => {
      if (this.props.onChange) {
        this.props.onChange(Object.values(this.state.answers));
      }
    });
  }

  renderQuestionInput(answer) {
    const isCheckboxOrRadioGroup = (answer.inputFieldTypeName === INPUT_TYPE_CHECKBOX || answer.inputFieldTypeName === INPUT_TYPE_RADIO) && answer.options?.length > 1;
    const isRange = answer.inputFieldTypeName === INPUT_TYPE_RANGE;
    const layoutType = isCheckboxOrRadioGroup || isRange ? INPUT_LAYOUT_TYPE_INLINE : this.props.layoutType;
    return (
      <InputControl
        input={{
          fieldName: answer.questionId + '',
          label: answer.label,
          inputType: answer.inputFieldTypeName,
          options: answer.options || [],
          dataType: DATA_TYPE_STRING,
          placeholder: answer.placeholder,
          tooltipText: answer.tooltipText,
          layoutType
        }}
        value={answer.answer || ''}
        onChange={(val) => this.handleAnswerChange(answer, val)}
        
      />
    );
  }

  render() {
    const { answers, heading } = this.props;

    if (!answers || !answers?.length) {
      // Don't render anything until answers are loaded
      // InputForm's isVisible logic should handle hiding this until typeId is selected
      return null;
    }

    const sections = {};
    answers.forEach(answer => {
      const sectionName = answer.sectionName || '';
      if (!sections[sectionName]) {
        sections[sectionName] = [];
      }
      sections[sectionName].push(answer);
    });

    return (
      !!answers?.length && (
        <>
          {!!heading && <h3 className="heading">{heading}</h3>}
          <div className="questions">
            {Object.entries(sections).map(([sectionName, sectionAnswers]) => (
              <div key={sectionName} className="section">
                {sectionName && <div className="heading">{sectionName}</div>}
                {sectionAnswers.map(answer => (
                  <div key={answer.questionId} className="question">
                    {this.renderQuestionInput(answer)}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </>
      )
    );
  }
}

QuestionAnswersUI.propTypes = {
  // Props passed from InputForm
  entityName: PropTypes.string.isRequired,
  typeId: PropTypes.number, // May be null initially
  recordId: PropTypes.number,      // May be null initially
  cacheKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func,

  // Props from Redux
  answers: PropTypes.arrayOf(PropTypes.shape({
    questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
    answer: PropTypes.any,
    options: PropTypes.array,
  })),
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const answers = selectQuestionAnswers( state, ownProps.entityName, ownProps.typeId ?? 0, ownProps.recordId ?? 0, ownProps.cacheKey );
  return { answers };
};

export default connect(mapStateToProps)(QuestionAnswersUI);
